import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CorporateService } from '../../../../_services/corporate/corporate.service';
import * as _ from 'underscore';
import * as moment from 'moment';

@Component({
  selector: 'app-expense-payment-details',
  templateUrl: './expense-payment-details.component.html',
  styleUrls: ['./expense-payment-details.component.css']
})
export class ExpensePaymentDetailsComponent implements OnInit {
  @Input() expenseFormGroup: FormGroup;
  @Input() tagMembers: Array<string>;
  @Input() displayControl;
  @Input() travellersDetails;
  isTravelUser: any = false;
  isEdit: any = false;
  isNewBill: any;
  loggedInUser: any;
  tagMembersList: any;
  urlID: any;

  constructor(
    private controlContainer: ControlContainer,
    private route: ActivatedRoute,
    private corporateService: CorporateService

  ) {
    if (window.localStorage.getItem('currentUser')) {
      this.loggedInUser = JSON.parse(window.localStorage.getItem('currentUser'));
      console.log(this.loggedInUser);
    }
    this.isNewBill = this.route.snapshot.queryParams['newBill'];
    console.log('isNewBill: ', this.isNewBill, typeof this.isNewBill);
    this.checkViewPermission()
  }

  checkViewPermission() {
    const bill = JSON.parse(sessionStorage.getItem('selectedBill'));
    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {
      this.isTravelUser = false
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '3421') {
      this.isTravelUser = true
    }
    if ((JSON.parse(localStorage.currentUser).roleValue == '9918' || '2898') && this.isNewBill != 'true') {
      this.isTravelUser = true;
      if (bill && !bill.paymentDetails) {
        this.isEdit = false
      } else {
        this.isEdit = true;
      }
    }
  }

  ngOnInit() {

    console.log('id ***', this.route.snapshot.params.id)
    this.urlID = this.route.snapshot.params.id

    this.expenseFormGroup = <FormGroup>this.controlContainer.control;
    console.log('tagmembers---', this.expenseFormGroup, this.tagMembers)
    const selBill = JSON.parse(sessionStorage.getItem('selectedBill'));

    this.corporateService.getTripSummaryById(this.urlID)
      .then((res) => {
        console.log('res ***', res)
        // this.defaultPurpose = res['purpose'];
        let travellerdetailsList

        _.each(res, function(o) {
      travellerdetailsList = o.travellerDetials || [];
          //console.log(o.bookingFor)
        })
        // _.each(res =>{
        //    travellerdetailsList = res.travellerDetials || [];
        // })


        let travellerdetails;
        travellerdetails = (_.pluck(travellerdetailsList, 'travellerName')) || " ";
        console.log("  this.defaultPurpose", this.tagMembersList);
        this.tagMembersList = travellerdetails.concat('Client', 'Company', 'Others');
        console.log("  this.defaultPurpose", this.tagMembersList);
      })
    // console.log('selBill-- ', selBill, !selBill.paymentDetails)

    if (selBill && selBill.invoiceDetails && selBill.invoiceDetails ?.state.length || selBill.invoiceDetails ?.city.length || selBill.basicDetails ?.category.length) {
      if (JSON.parse(localStorage.currentUser).roleValue != '5672') {
        if (!selBill.paymentDetails) {
          this.isEdit = false
        } else {
          this.isEdit = true
        }
      }
    }
    if (selBill && selBill.paymentDetails && selBill.paymentDetails.paidBy == '') {
      this.isEdit = false
    }
    if (selBill.key == this.loggedInUser.employeeCode) {
      this.isTravelUser = false;
    }
    if (selBill && selBill.reimbursementDetails && selBill.reimbursementDetails.isApplicable == 'Yes') {
      this.isTravelUser = true;
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {

      if (selBill && selBill.approvalDetails && selBill.approvalDetails.approvalStatus == "pending") {
        this.isTravelUser = true;
        // this.isEdit = true;
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {

      if (selBill && selBill.approvalDetails && selBill.approvalDetails.approvalStatus == "draft") {
        this.isTravelUser = false;
        // this.isEdit = true;
      } else {
        this.isTravelUser = true
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {

      if (selBill && !selBill.approvalDetails) {
        this.isTravelUser = false;
        // this.isEdit = true;
      } else {
        this.isTravelUser = true
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {
      if (selBill && selBill.approvalDetails) {
        if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus === "pending" || "approved") {
          this.isTravelUser = true;
        }
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {
      if (selBill && selBill.approvalDetails) {
        if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus === "draft") {
          this.isTravelUser = false;
        }
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {
      if (selBill && selBill.approvalDetails) {
        if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus === "") {
          this.isTravelUser = false;
        }
      }
    }
    // if (JSON.parse(localStorage.currentUser).roleValue == '5672') {
    //
    //   if (selBill && !selBill.expenseBillDetails) {
    //     this.isTravelUser = false;
    //     // this.isEdit = true;
    //   } else {
    //     this.isTravelUser = true
    //   }
    // }
    if ((JSON.parse(localStorage.currentUser).roleValue !== '5672')) {

      if (selBill && !selBill.expenseBillDetails) {
        this.isTravelUser = false;
        // this.isEdit = true;
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue === '3421') {
      this.isTravelUser = true
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '9918') {

      if (selBill && selBill.approvalDetails && selBill.approvalDetails.approvalStatus == "pending") {
        this.isTravelUser = true;
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '9918') {
      if (selBill && selBill.approvalDetails) {
        if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus === "approved") {
          this.isTravelUser = true;
        }
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '9918') {
      if (selBill && selBill.approvalDetails) {
        if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus == "rejected") {
          this.isTravelUser = true;
        }
      }
    }
    //  this.getTripSummaryData();


  }



  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onValueSelect(event) {
    console.log('value Selected:', event)
  }

}
